import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
  const { currentUser, employeeData } = useAuth();

  // If no Firebase Auth user or no employee data, redirect to login
  if (!currentUser || !employeeData) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;























